import request from "@/utils/request";
import { apiConfig } from "../config/api";

// 用户测评信息分页列表
export function getUserAssessPager(req, page) {
  return request({
    url: apiConfig.userAssess.api.pager.url,
    method: "post",
    data: {
      realName: req.realName,
      idNumber: req.idNumber,
      projectName: req.projectName,
      projectId: req.projectId,
      assessStatus: req.assessStatus,
      agentId: req.agentId,
      startDate: req.startDate,
      endDate: req.endDate,
      page: page.page,
      pageSize: page.pageSize
    }
  });
}

// 用户测评信息分页列表搜索功能
export function searchUserAssessPager(req, page) {
  return request({
    url: apiConfig.userAssess.api.pager.url,
    method: "post",
    data: {
      realName: req.realName,
      idNumber: req.idNumber,
      projectName: req.projectName,
      projectId: req.projectId,
      assessStatus: req.assessStatus,
      agentId: req.agentId,
      startDate: req.startDate,
      endDate: req.endDate,
      page: page.page,
      pageSize: page.pageSize
    }
  });
}
// 查看测评详情
export function getScaleList(req) {
  return request({
    url: apiConfig.userAssess.api.getScaleList.url,
    method: "post",
    data: {
      realName: req.realname,
      idNumber: req.idNumber,
      registerFrom: req.registerFrom,
      baseInfoAuditStatus: req.baseInfoAuditStatus,
      startDate: req.startDate,
      endDate: req.endDate
    }
  });
}
// 查看测评报告
export function viewReport(req) {
  return request({
    url: apiConfig.userAssess.api.viewReport.url,
    method: "get",
    params: req
  });
}
// 下载测评报告
export function downloadReport(req) {
  return request({
    url: apiConfig.userAssess.api.downloadReport.url,
    method: "get",
    params: req,
    responseType: "blob"
  });
}
// 批量下载测评报告
export function downloadReportBatch(req) {
  return request({
    url: apiConfig.userAssess.api.downloadReportBatch.url,
    method: "post",
    data: {
      realName: req.realname,
      idNumber: req.idNumber,
      registerFrom: req.registerFrom,
      baseInfoAuditStatus: req.baseInfoAuditStatus,
      startDate: req.startDate,
      endDate: req.endDate
    }
  });
}
export function getScaleListByProId(req) {
  return request({
    url: apiConfig.userAssess.api.getScaleList.url,
    method: "get",
    params: {
      projectId: req.projectId,
      userId: req.userId
    }
  });
}
